import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  active: true,
  description: () => faker.lorem.sentence(),
  identifier: () => faker.lorem.slug(),
  title: () => faker.lorem.word(),

  withAttachment: trait({
    afterCreate(userDocumentTemplate, server) {
      server.create('user-document-template-attachment', { userDocumentTemplate });
    },
  }),

  withAttachments: trait({
    afterCreate(userDocumentTemplate, server) {
      server.createList('user-document-template-attachment', 2, { userDocumentTemplate });
    },
  }),

  withDateIssued: trait({
    inputFields: [
      {
        type: 'date',
        title: 'Date Issued',
        position: 0,
        required: true,
        identifier: 'issue_date',
        default_value: null,
      },
    ],
  }),

  asCovidVaccineCard: trait({
    illustrationImageUrl: '/assets/images/covid-19-vaccine-card.svg',
    identifier: 'covid-19-vaccine-card',
    title: 'Vaccination Record',
    description:
      'Envoy now has an easy and secure way to get your proof of vaccination to your office. Get started now to add your vaccination record to your profile.',
    inputFields: [
      {
        default_value: null,
        identifier: 'last_dose_date',
        position: 0,
        required: true,
        title: 'Last dose administered',
        type: 'date',
      },
    ],
    afterCreate(userDocumentTemplate, server) {
      server.create('user-document-template-attachment', {
        userDocumentTemplate,
        identifier: 'covid-19-vaccine-card-front',
        title: 'Front side',
        required: true,
        position: 1,
      });
      server.create('user-document-template-attachment', {
        userDocumentTemplate,
        identifier: 'covid-19-vaccine-card-back',
        title: 'Back side',
        required: false,
        position: 2,
      });
    },
  }),

  asCovidTestResult: trait({
    illustrationImageUrl: '/assets/images/covid-19-test-result.svg',
    identifier: 'covid-19-test-result',
    title: 'Test result',
    description:
      'To facilitate a safer working environment for all, we are requesting proof of negative test results. Submit your test result and we will review and approve it. Please contact your admin if you plan to opt out.',
    inputFields: [
      {
        type: 'date',
        title: 'Date Issued',
        position: 0,
        required: true,
        identifier: 'issue_date',
        default_value: null,
      },
    ],
    afterCreate(userDocumentTemplate, server) {
      server.create('user-document-template-attachment', {
        userDocumentTemplate,
        title: 'test result',
        identifier: 'covid-19-test-result',
        required: true,
        position: 1,
      });
    },
  }),

  asIdentificationCard: trait({
    illustrationImageUrl: null,
    identifier: 'identification-card',
    title: 'Identification document',
    description: 'Require visitors to scan a government-issued ID to come on-site.',
    inputFields: [
      {
        type: 'date',
        title: 'Expiration Date',
        position: 0,
        required: false,
        identifier: 'expiration_date',
        default_value: null,
      },
    ],
  }),
});
